var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPositiveNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H5V8H3V11H0V13H3V16H5V13H8V11Z",
    id: "plus"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11H16V13H24V11Z",
    id: "minus"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H9L13 3H15L11 21Z",
    id: "slash"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPositiveNegative);
export default __webpack_public_path__ + "static/media/icon-positive-negative.4189f7aa7e01921a21e56e0a7e87cef6.svg";
export { ForwardRef as ReactComponent };